import { Button } from '../../components/Buttons'
import img from './assets/AccessDenied.svg'

import { s } from './styles'

type Props = {
  title?: string
  subTitle?: string
}

export const AccessDenied = (props: Props) => {
  const { title, subTitle } = props

  return (
    <s.Box>
      <s.Img dangerouslySetInnerHTML={{ __html: img }} />
      <s.Title>{title || "You can't view this page"}</s.Title>
      <s.SubTitle>{subTitle || "You don't have permission to view this page."}</s.SubTitle>
      <a href="/">
        <Button face="primary">Go home</Button>
      </a>
    </s.Box>
  )
}
